import {
  IonGrid,
  IonRow,
  IonCol,
  IonContent,
  IonLabel,
  IonInput,
  IonPage,
  IonButton,
  IonModal,
  IonFooter,
} from "@ionic/react";
import React from "react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import ErrorTopToaster from "../../components/ErrorTopToaster";
import CancelModal from "../../components/modals/cancel-modal";
import { ActionType, MailType } from "../../models/Enums";
import { SetPasswordAuth } from "../../services/AuthServices";
import TopLeftUserName from "../../components/TopLeftUserName";
import { networkConnectionStatus } from "../../data/atoms";
import { useRecoilState } from "recoil";
import { localDateTime } from "../../utils/sharedFunction";
import ExitModal from "../../components/modals/exit-modal";

interface Props {
  actionType: any;
}
const PasswordReset: React.FC<Props> = ({ actionType }) => {
  console.log("password reset action type: ", actionType);
  const [shown, setShown] = useState(false);
  const [shown1, setShown1] = useState(false);
  const [isDisabledBtn1, setIsDisabledBtn1] = useState(true);
  const [isDisabledBtn2, setIsDisabledBtn2] = useState(true);
  const [cancelModal, setShowModal1] = useState(false);
  const [ShowNetWorkRecoil, setShowNetWorkRecoil] = useRecoilState(
    networkConnectionStatus
  );
  let history = useHistory();

  const {
    register,
    getValues,
    handleSubmit,
    setError,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      password: "",
      newPassword: "",
    },
  });

  async function UpdatePasssword(Password: string, confirmPassword: string) {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    try {
      if (Password === confirmPassword) {
        let businessType = localStorage.getItem("BusinessType");
        await SetPasswordAuth({
          Email: localStorage.getItem("resetEmail"),
          UserName: localStorage.getItem("Username"),
          MailType: MailType.PasswordChangedSuccessfullEmail,
          LoggedInUserID: localStorage.getItem("UserID"),
          encryptedServerId: localStorage.getItem("EncryptedServerId"),
          Password: Password,
          WorkstationId: localStorage.getItem("WorkstationId"),
          LocationId: localStorage.getItem("LocationId"),
          BusinessType: businessType ? +businessType : 0,
          LocalDateTime: localDateTime(),
          IsPwdUpdateFromProfile: false,
        })
          .then(async function (response) {
            if (response!.data.isResponseSuccessfull) {
              reset();
              localStorage.setItem("resetEmail", "");
              setShown(false);
              setShown1(false);
              history.push("/confirmation", {
                actionType: ActionType.SuccessPasswordReset,
              });
            } else {
              console.log(errors);
              setError("password", {
                type: "server",
                message: response!.data.errorMessage,
              });
              setError("newPassword", {
                type: "server",
                message: response!.data.errorMessage,
              });
            }
          })
          .catch((error) => {
            history.push("/confirmation", {
              actionType: ActionType.FailureAPIResponse,
            });
          });
      }
    } catch (error) {
      history.push("/confirmation", {
        actionType: ActionType.FailureAPIResponse,
      });
      console.error(error);
    }
  }

  async function checkDisableTextValidityBtn1(event: any) {
    if (event.target.value !== "" && event.target.value.trim().length !== 0) {
      setIsDisabledBtn1(false);
    } else {
      setIsDisabledBtn1(true);
    }
  }
  async function checkDisableTextValidityBtn2(event: any) {
    if (event.target.value !== "" && event.target.value.trim().length !== 0) {
      setIsDisabledBtn2(false);
    } else {
      setIsDisabledBtn2(true);
    }
  }

  const actionTypeFlow =
    localStorage.getItem("isOtpFlow") === "true"
      ? ActionType.ExitExpiredPassword
      : ActionType.ExitForgotPassword;

  return (
    <IonPage placeholder={undefined}>
      <TopLeftUserName
        headerText={"Password Reset"}
        actionType={
          actionType == ActionType.NewUser
            ? ActionType.ExitUserSetup
            : ActionType.ExitForgotPassword
        }
        exitModal={() => setShowModal1(true)}
      ></TopLeftUserName>
      <IonModal
        className="cancel-modal"
        backdropDismiss={false}
        isOpen={cancelModal}
        placeholder={undefined}
      >
        <CancelModal
          setShowModal1={setShowModal1}
          actionType={ActionType.SuccessPasswordReset}
          reset={reset}
          isEdit={false}
        ></CancelModal>
      </IonModal>
      <IonModal
        className="overall-center-modal-main-wrap"
        backdropDismiss={false}
        isOpen={cancelModal}
        placeholder={undefined}
      >
        <ExitModal
          setShowModal1={setShowModal1}
          actionType={actionTypeFlow}
          reset={reset}
          isEdit={false}
        ></ExitModal>
      </IonModal>
      <IonContent placeholder={undefined} className="slide-in-right">
        <IonGrid
          className="container login-pages-top-spacing"
          placeholder={undefined}
        >
          <IonRow className="row" placeholder={undefined}>
            <IonCol placeholder={undefined}>
              <div className="top-inner-sec login-pages-space">
                <h1>Create New Password</h1>
                <p className="password-reset-text">
                  Password should be a minimum of 8 characters with at least one
                  upper case letter and a digit, or a special character.
                </p>
              </div>
              <form
                onSubmit={handleSubmit((data) => {
                  if (data.password === data.newPassword) {
                    UpdatePasssword(data.password, data.newPassword);
                  }
                })}
                autoComplete="off"
              >
                <div
                  className={`field-wrap ${errors.password && "error-wrap"}`}
                >
                  <IonLabel className="label" placeholder={undefined}>
                    Password *
                  </IonLabel>
                  <IonInput
                    className="input-field"
                    type={shown ? "text" : "password"}
                    placeholder="Enter password"
                    {...register("password", {
                      required: true,
                      minLength: 8,
                      validate: (value) => value === getValues("newPassword"),
                      pattern:
                        /^(?=.*[!@#$%^&*_0-9])(?=.*[A-Z])([^\\s])[a-zA-Z0-9!@#$%^&*_]{7,}$/,
                    })}
                    onIonChange={(e) => {
                      checkDisableTextValidityBtn1(e);
                    }}
                  ></IonInput>
                  <div className="eye-icon" onClick={() => setShown(!shown)}>
                    {shown ? (
                      <svg
                        className="eye-ist-icon"
                        width="22"
                        height="14"
                        viewBox="0 0 22 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11 13C16.5228 13 21 7 21 7C21 7 16.5228 1 11 1C5.47715 1 1 7 1 7C1 7 5.47715 13 11 13Z"
                          stroke="#D1D1D1"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M11 9C12.1046 9 13 8.10457 13 7C13 5.89543 12.1046 5 11 5C9.89543 5 9 5.89543 9 7C9 8.10457 9.89543 9 11 9Z"
                          stroke="#D1D1D1"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    ) : (
                      <svg
                        className="eye-sec-icon"
                        width="17"
                        height="14"
                        viewBox="0 0 17 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.5 2.77517C10.6327 2.77517 12.3636 4.48649 12.3636 6.59509C12.3636 6.98472 12.2864 7.35907 12.1782 7.71051L14.5427 10.0483C15.6168 9.10859 16.4668 7.93206 17 6.58745C15.6632 3.2412 12.3636 0.865211 8.5 0.865211C7.51864 0.865211 6.57591 1.01801 5.68727 1.30068L7.36409 2.95853C7.72727 2.85157 8.10591 2.77517 8.5 2.77517ZM1.32136 0.223465C1.02 0.521419 1.02 1.00273 1.32136 1.30068L2.84364 2.80573C1.59182 3.79127 0.595 5.09004 0 6.59509C1.33682 9.94898 4.63636 12.325 8.5 12.325C9.67455 12.325 10.795 12.0958 11.8305 11.6985L13.9323 13.7765C14.2336 14.0745 14.7205 14.0745 15.0218 13.7765C15.3232 13.4786 15.3232 12.9973 15.0218 12.6993L2.41864 0.223465C2.11727 -0.0744884 1.62273 -0.0744884 1.32136 0.223465ZM8.5 10.415C6.36727 10.415 4.63636 8.70368 4.63636 6.59509C4.63636 6.00682 4.77545 5.44911 5.015 4.96016L6.22818 6.15962C6.205 6.29714 6.18182 6.44229 6.18182 6.59509C6.18182 7.8633 7.21727 8.88704 8.5 8.88704C8.65454 8.88704 8.79364 8.86412 8.94045 8.83356L10.1536 10.033C9.65136 10.2775 9.095 10.415 8.5 10.415ZM10.795 6.34297C10.6791 5.2734 9.82909 4.44065 8.755 4.32606L10.795 6.34297Z"
                          fill="#D1D1D1"
                        />
                      </svg>
                    )}
                  </div>

                  <div className="error-wrap">
                    {errors?.password?.type === "minLength" && (
                      <p className="error-msg">
                        Password doesn’t meet requirements
                      </p>
                    )}
                    {errors?.password?.type === "pattern" && (
                      <p className="error-msg">
                        Password doesn’t meet requirements
                      </p>
                    )}
                    {errors?.password?.type === "validate" && (
                      <p className="error-msg">Passwords don’t match</p>
                    )}
                    {errors.password &&
                      errors.password.type === "server" &&
                      errors.password.message && (
                        <ErrorTopToaster
                          errorString={errors.password.message}
                        />
                      )}
                  </div>
                </div>

                <div
                  className={`field-wrap ${errors.newPassword && "error-wrap"}`}
                >
                  <IonLabel className="label" placeholder={undefined}>
                    Re-enter Password *
                  </IonLabel>
                  <IonInput
                    className="input-field"
                    type={shown1 ? "text" : "password"}
                    //disabled={errors?.password?.type === "minLength" || errors?.password?.type === "pattern" ? true : false}
                    placeholder="Retype password"
                    {...register("newPassword", {
                      required: true,
                      // minLength: 8,
                      validate: (value) =>
                        value === getValues("password") ||
                        "Passwords don’t match",
                      pattern:
                        /^(?=.*[!@#$%^&*_0-9])(?=.*[A-Z])([^\\s])[a-zA-Z0-9!@#$%^&*_]{7,}$/,
                    })}
                    onIonChange={(e) => {
                      checkDisableTextValidityBtn2(e);
                    }}
                  ></IonInput>

                  <div className="eye-icon" onClick={() => setShown1(!shown1)}>
                    {shown1 ? (
                      <svg
                        className="eye-ist-icon"
                        width="22"
                        height="14"
                        viewBox="0 0 22 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11 13C16.5228 13 21 7 21 7C21 7 16.5228 1 11 1C5.47715 1 1 7 1 7C1 7 5.47715 13 11 13Z"
                          stroke="#D1D1D1"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M11 9C12.1046 9 13 8.10457 13 7C13 5.89543 12.1046 5 11 5C9.89543 5 9 5.89543 9 7C9 8.10457 9.89543 9 11 9Z"
                          stroke="#D1D1D1"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    ) : (
                      <svg
                        className="eye-sec-icon"
                        width="17"
                        height="14"
                        viewBox="0 0 17 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.5 2.77517C10.6327 2.77517 12.3636 4.48649 12.3636 6.59509C12.3636 6.98472 12.2864 7.35907 12.1782 7.71051L14.5427 10.0483C15.6168 9.10859 16.4668 7.93206 17 6.58745C15.6632 3.2412 12.3636 0.865211 8.5 0.865211C7.51864 0.865211 6.57591 1.01801 5.68727 1.30068L7.36409 2.95853C7.72727 2.85157 8.10591 2.77517 8.5 2.77517ZM1.32136 0.223465C1.02 0.521419 1.02 1.00273 1.32136 1.30068L2.84364 2.80573C1.59182 3.79127 0.595 5.09004 0 6.59509C1.33682 9.94898 4.63636 12.325 8.5 12.325C9.67455 12.325 10.795 12.0958 11.8305 11.6985L13.9323 13.7765C14.2336 14.0745 14.7205 14.0745 15.0218 13.7765C15.3232 13.4786 15.3232 12.9973 15.0218 12.6993L2.41864 0.223465C2.11727 -0.0744884 1.62273 -0.0744884 1.32136 0.223465ZM8.5 10.415C6.36727 10.415 4.63636 8.70368 4.63636 6.59509C4.63636 6.00682 4.77545 5.44911 5.015 4.96016L6.22818 6.15962C6.205 6.29714 6.18182 6.44229 6.18182 6.59509C6.18182 7.8633 7.21727 8.88704 8.5 8.88704C8.65454 8.88704 8.79364 8.86412 8.94045 8.83356L10.1536 10.033C9.65136 10.2775 9.095 10.415 8.5 10.415ZM10.795 6.34297C10.6791 5.2734 9.82909 4.44065 8.755 4.32606L10.795 6.34297Z"
                          fill="#D1D1D1"
                        />
                      </svg>
                    )}
                  </div>

                  <div className="error-wrap">
                    {errors?.password?.type === "validate" && (
                      <p className="error-msg">Passwords don’t match</p>
                    )}
                    {errors.newPassword &&
                      errors.newPassword.type === "server" &&
                      errors.newPassword.message && (
                        <ErrorTopToaster
                          errorString={errors.newPassword.message}
                        />
                      )}
                  </div>
                </div>
              </form>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
      <IonFooter placeholder={undefined}>
        <div className="container">
          <div className="btn-wrap-sec two-btns extra-btn-space-wrap">
            <IonButton
              className="generic-btn generic-btn-outline"
              onClick={() => {
                reset();
                history.push("/confirmation", {
                  actionType:
                    actionType === ActionType.NewUser
                      ? ActionType.ExitUserSetup
                      : actionTypeFlow,
                });
              }}
              placeholder={undefined}
            >
              Cancel
            </IonButton>
            <IonButton
              className="generic-btn"
              type="button"
              disabled={isDisabledBtn1 || isDisabledBtn2}
              placeholder={undefined}
              onClick={handleSubmit((data) => {
                console.log(data);
                if (data.password === data.newPassword) {
                  UpdatePasssword(data.password, data.newPassword);
                }
              })}
            >
              Confirm
            </IonButton>
          </div>
        </div>
      </IonFooter>
    </IonPage>
  );
};

export default PasswordReset;

function useNavigate() {
  throw new Error("Function not implemented.");
}
